import { GithubOutlined, PhoneOutlined, GlobalOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${new Date().getFullYear()} 深圳分声科技 提供技术服务支持`}
      links={[
        {
          key: '服务热线',
          title: (
            <>
              <PhoneOutlined style={{ marginRight: 8 }} />
              服务热线：10086
            </>
          ),
          href: 'tel:10086',
          blankTarget: false,
        },
        {
          key: '营业厅',
          title: (
            <>
              <CustomerServiceOutlined style={{ marginRight: 8 }} />
              营业厅查询
            </>
          ),
          href: 'https://10086.cn',
          blankTarget: true,
        },
        {
          key: '官网',
          title: (
            <>
              <GlobalOutlined style={{ marginRight: 8 }} />
              中国移动官网
            </>
          ),
          href: 'https://10086.cn',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://github.com/ant-design/ant-design-pro',
          blankTarget: true,
        },
        {
          key: '深圳分声科技提供技术支持',
          title: '技术支持',
          href: '#',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
